/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { ChannelsRepositoryImpl } from '../impls/ChannelsServiceRepositoryImpl';
import { IChannelsServiceRepository } from '../interfaces/IChannelsServiceRepository';
import { TChannels } from '../types/TChannels';
import { TServicesParams } from '../types/TServicesParams';
import { Channel } from '../entities/Channel';
import { ChannelsType } from '../types/TChannelsType';

export class ChannelsService implements IChannelsServiceRepository {
    private oChannelsServiceRepository: IChannelsServiceRepository;

    constructor(params: TServicesParams) {
        this.oChannelsServiceRepository = new ChannelsRepositoryImpl(params);
    }

    async fetchMyChannels(offset?: number, limit?: number): Promise<TChannels> {
        return this.oChannelsServiceRepository.fetchMyChannels(offset, limit);
    }

    async fetchAllChannels(offset?: number, limit?: number): Promise<TChannels> {
        return this.oChannelsServiceRepository.fetchAllChannels(offset, limit);
    }

    public getNextChannel(channelNumber: string, channelsType: string, count?: number): Promise<Channel> {
        return this.oChannelsServiceRepository.getNextChannel(channelNumber, channelsType, count);
    }

    public getPreviousChannel(channelNumber: string, channelsType: string, count?: number): Promise<Channel> {
        return this.oChannelsServiceRepository.getPreviousChannel(channelNumber, channelsType, count);
    }

    tuneToChannel(channelNumber: string): Promise<Channel> {
        return this.oChannelsServiceRepository.tuneToChannel(channelNumber);
    }

    async fetchNextChannelsFromChannelNumber(
        channelNumber: string,
        channelsType: ChannelsType,
        limit: number,
    ): Promise<TChannels> {
        return this.oChannelsServiceRepository.fetchNextChannelsFromChannelNumber(
            channelNumber,
            channelsType,
            limit,
        );
    }

    updateChannelUrl(channelNumber: string, url: string) {
        return this.oChannelsServiceRepository.updateChannelUrl(channelNumber, url);
    }
}
